import styled from 'styled-components';
import radio from '~/components/styled/radio';
import media from '~/utils/media';

export const Content = styled.div`
  padding: 0 7.03% 30px;
  background-color: #e2edff;
  box-shadow: inset 7px -7px 10px -5px rgba(6, 0, 1, 0.1), inset -7px -7px 10px -5px rgba(6, 0, 1, 0.1);
`;

export const Card = styled.div`
  background-color: #fff;

  ${media.pcLarge`
    padding: 40px;
  `}

  ${media.tabletLarge`
    padding: 40px;
  `}

  ${media.tabletSmall`
    padding: 30px;
  `}

  ${media.mobileLarge`
    padding: 30px;
  `}

  ${media.mobileMid`
    padding: 8px;
  `}

  ${media.mobileSmall`
    padding: 8px;
  `}
`;

export const Title = styled.h1`
  color: #1f2020;

  ${media.pcLarge`
    font-size: 25px;
  `}

  ${media.tabletLarge`
    font-size: 20px;
  `}

  ${media.tabletSmall`
    font-size: 20px;
  `}

  ${media.mobileLarge`
    font-size: 15px;
  `}

  ${media.mobileMid`
    font-size: 15px;
  `}

  ${media.mobileSmall`
    font-size: 15px;
  `}
`;

export const Question = styled.h2`
  margin-bottom: 10px;
  color: #456498;
  letter-spacing: -1px;

  ${media.pcLarge`
    margin-top: 40px;
    font-size: 20px;
  `}

  ${media.tabletLarge`
    margin-top: 30px;
    font-size: 20px;
  `}

  ${media.tabletSmall`
    margin-top: 20px;
    font-size: 15px;
  `}

  ${media.mobileLarge`
    margin-top: 10px;
    font-size: 15px;
  `}

  ${media.mobileMid`
    margin-top: 10px;
    font-size: 13px;
    line-height: 20px;
  `}

  ${media.mobileSmall`
    margin-top: 10px;
    font-size: 11px;
    line-height: 20px;
  `}
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  letter-spacing: -1px;

  > p {
    flex: none;
    font-weight: 700;
  }

  ${media.pcLarge`
    height: 35px;
    font-size: 16px;

    & + & {
      margin-top: 10px;
    }
  `}

  ${media.tabletLarge`
    height: 35px;
    font-size: 15px;

    & + & {
      margin-top: 5px;
    }
  `}

  ${media.tabletSmall`
    height: 25px;
    font-size: 15px;

    & + & {
      margin-top: 5px;
    }
  `}

  ${media.mobileLarge`
    height: 25px;
    font-size: 12px;
 
    & + & {
      margin-top: 2px;
    }
  `}

  ${media.mobileMid`
    height: 25px;
    font-size: 12px;

    & + & {
      margin-top: 2px;
    }
  `}

  ${media.mobileSmall`
    height: 25px;
    font-size: 10px;

    & + & {
      margin-top: 2px;
    }
  `}
`;

export const Radio = styled.input.attrs({
  type: 'radio',
})`
  ${radio};
  flex: none;
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

export const Input = styled.input.attrs({
  type: 'text',
})`
  flex-grow: 1;
  width: 0;
  height: 76%;
  margin-left: 8px;
  border: 0;
  border-radius: 2px;
  background-color: #e5e5e5;

  &:focus {
    outline: none;
  }
`;
